import { serviceMaker, methods, api } from "@/http/index.js";

export const getPlanValidationRulesList = () =>
  serviceMaker(`/planvalidationrules`, methods.GET, api.NGB);
export const getPlanValidationRulesTemplate = () =>
  serviceMaker(`/planvalidationrules/template`, methods.GET, api.NGB);
export const getPlanValidationRuleById = (id) =>
  serviceMaker(`/planvalidationrules/${id}`, methods.GET, api.NGB);
export const createPlanValidationRule = (data) =>
  serviceMaker(`/planvalidationrules`, methods.POST, api.NGB, data);
export const createValidationRule = (data) =>
  serviceMaker(`/planvalidationrules/create`, methods.POST, api.NGB, data);
export const editValidationRule = (id, data) =>
  serviceMaker(`/planvalidationrules/plan/${id}`, methods.PUT, api.NGB, data);
export const getValidationRules = (id) =>
  serviceMaker(`/planvalidationrules/plan/${id}`, methods.GET, api.NGB);
export const editPlanValidationRule = (id, data) =>
  serviceMaker(`/planvalidationrules/${id}`, methods.PUT, api.NGB, data);
export const deletePlanValidationRule = (id) =>
  serviceMaker(`/planvalidationrules/${id}`, methods.DELETE, api.NGB);
